import { types } from 'mobx-state-tree';


const GARAGE_SIZES = {
    SINGLE: 'single',
    DOUBLE: 'double',
    TRIPLE: 'triple',
    NONE: 'none',
};

const GarageSizeEnum = types.enumeration('GarageSize', Object.values(GARAGE_SIZES));

export {
    GarageSizeEnum,
};
export default GARAGE_SIZES;
